import { computed, toValue } from 'vue';
import {
  useQuery,
  type DefaultError,
  type QueryKey,
} from '@tanstack/vue-query';
import type { QueryOptionsFor } from './useScopedQuery';
import type { QueryFlags } from './types';

/**
 * An observer over an installation-wide catalogue: one list for everyone.
 */
export function useCatalogueQuery<
  TData,
  TError = DefaultError,
  TQueryKey extends QueryKey = QueryKey,
>(
  optionsFor: () => QueryOptionsFor<TData, TError, TQueryKey>,
  { enabled = true }: QueryFlags = {}
) {
  const options = computed(() => ({
    ...optionsFor(),
    enabled: toValue(enabled),
    shallow: true,
    refetchOnWindowFocus: true,
  }));

  return useQuery(options);
}
